<script>
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import { cloneDeep, groupBy } from "lodash";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Multiselect from "vue-multiselect";
import RawData from "@/components/widgets/raw-data.vue";

export default {
    name: "cart-items",
    components: {
        MaskedInput,
        Multiselect,
        RawData
    },
    props: {
        tableData: {
            type: Array,
            default: () => [],
        },
        draftRealignment: {
            type: Object,
            default: () => null,
        },
    },
    data(){
        return{
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            quantityMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
                allowDecimal: false,
            }),
            filter: "",
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            currentPage: 1,
            showPO: false,
            realignmentDescription: "",
            totalReduceQty: 0,
            reason: 0,
            notes: "",
            submitted: false,
            modificationProposal: [],
            proposalCopy: [],
            addMore: false,
            proposal: {
                id: 0,
                accountId: null,
                account: null,
                q1: null,
                q2: null,
                q3: null,
                q4: null,
            },
            quarterOptions: [
                {
                    text: "1st Quarter",
                    value: 1,
                },
                {
                    text: "2nd Quarter",
                    value: 2,
                },
                {
                    text: "3rd Quarter",
                    value: 3,
                },
                {
                    text: "4th Quarter",
                    value: 4,
                },
            ],
            availableAccounts: [],
            proposalLoading: false,
            accountsLoading: false,
            selectedAPI: null,
            selectedOPCR: null,
            selectedTarget: null,
            newApiName: "",
            apiId: "",
            newApiOpcrId: "",
            newApiTargetId: "",
            availableApis: [],
            proposalLoaded: false,
            reasons: [
                'Unforeseen modification or adjustment in the Activity/Program/Initiative (API)',
                'Re-assessment in the use. Prioritization and/or distribution of resources',
                'Additional requirements for an API in view of a declaration of a state of calamity',
            ],
            opcrs: [],
            targets: [],
        }
    },
    validations: {
        realignmentDescription: {required},
        notes: {required},
        // apiId: {required},
        newApiName: {required},
        proposal: { accountId: {required} },
        newApiOpcrId: {required},
        newApiTargetId: {required},
    },
    mounted(){
        if(this.draftRealignment){
            this.realignmentDescription = this.draftRealignment.description;
        }
        this.getAvailableAccounts();
        this.getOpcrs();
        this.getTargets();
    },
    computed: {
        filtered(){
            let data = this.tableData;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.apiResourceDetail.apiResource.itemName
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.tableData;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.apiResourceDetail.apiResource.itemName
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        totalLineBudget(){
            return this.tableData.reduce((pv, cv) => {
                return pv + (parseFloat(cv.total));
            }, 0);
        },
        totalExpenditure(){
            let sum = this.proposalCopy.reduce((pv, cv) => {
                return pv + (parseFloat(cv.q1) + parseFloat(cv.q2) + parseFloat(cv.q3) + parseFloat(cv.q4));
            }, 0);
            let q1 = this.proposal.q1 ? parseFloat(this.getExactAmt(this.proposal.q1)) : 0;
            let q2 = this.proposal.q2 ? parseFloat(this.getExactAmt(this.proposal.q2)) : 0;
            let q3 = this.proposal.q3 ? parseFloat(this.getExactAmt(this.proposal.q3)) : 0;
            let q4 = this.proposal.q4 ? parseFloat(this.getExactAmt(this.proposal.q4)) : 0;
            let total = sum + q1 + q2 + q3 + q4;
            return total;
        }
    },
    methods: {
        async getTargets(){
            await this.$store
                .dispatch("target/GetMyTarget", {
                    deliveryUnitId: this.$store.state.data.selectedDU.id,
                    cycle: this.$store.state.data.cycle
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    this.targets = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong getting OPCR!", "error");
                })
        },
        async getOpcrs(){
            await this.$store
                .dispatch("opcr/GetAllOpcr", {
                    deliveryUnitId: this.$store.state.data.selectedDU.id,
                    cycle: this.$store.state.data.cycle
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    this.opcrs = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong getting draft OPCR!", "error");
                })
        },
        async getAvailableAccounts(data) {
            this.availableAccounts = [];
            this.accountsLoading = true;
            await this.$store
                .dispatch("accounts/getAccountsForExpense", data)
                .then((response) => {
                    if(response.data.error){
                        return this.showToast(response.data.errorMessage, 'error');
                    }
                    // response.data.map(item => {
                    //     item.accountNameWithGroup = item.accountName + '(' + item.accountGroup.groupName + ')';
                    //     item.accountTrimmed = item.accountName.replace(/\s/g, '').trim().toLowerCase();
                    // })
                    var grps = [];
                    let grp = groupBy(response.data, 'accountGroupId');
                    for(var key in grp){
                        grps.push({
                            id: grp[key][0].id,
                            accountGroup: grp[key][0].accountGroup.groupName
                        })
                    }
                    this.availableAccounts = grps.sort((a, b) => a.accountGroup.localeCompare(b.accountGroup));
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            this.accountsLoading = false;
        },
        deleteItem(id){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("realignmentrequestitem/DeleteRealignment", id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.$emit("delete-item", id);
                            }
                        })
                    }
            });
        },
        autoGrow(element, size) {
            element.target.style.height = `${size}px`;
            element.target.style.height = `${element.target.scrollHeight}px`;
        },
        async updateRealignment(){
            this.showPO = true;
            this.realignmentDescription = this.draftRealignment.description;
            this.notes = this.draftRealignment.note;
            this.reason = this.draftRealignment.reason;
            // await this.getAvailableApis();
            // this.apiId = this.draftRealignment.apiId;
            this.newApiName = this.draftRealignment.newApiName;
            this.newApiOpcrId = this.draftRealignment.newApiOpcrId;
            this.selectedOPCR = this.opcrs.find((item) => item.id == this.draftRealignment.newApiOpcrId);
            this.newApiTargetId = this.draftRealignment.newApiTargetId;
            this.selectedTarget = this.targets.find((item) => item.id == this.draftRealignment.newApiTargetId);
        },
        createRequest(){
            this.submitted = true;
            this.$v.realignmentDescription.$touch();
            this.$v.notes.$touch();
            // this.$v.apiId.$touch();
            this.$v.newApiName.$touch();
            this.$v.newApiOpcrId.$touch();
            this.$v.newApiTargetId.$touch();
            if (this.$v.realignmentDescription.$invalid) {
                return;
            }
            if (this.$v.notes.$invalid) {
                return;
            }
            // if (this.$v.apiId.$invalid) {
            //     return;
            // }
            if (this.$v.newApiName.$invalid) {
                return;
            }
            if (this.$v.newApiOpcrId.$invalid) {
                return;
            }
            if (this.$v.newApiTargetId.$invalid) {
                return;
            }
            if(this.reason == 0){
                return;
            }
            if(this.draftRealignment){
                this.$store
                    .dispatch("realignmentrequest/UpdateRealignment", 
                        {
                            id: this.draftRealignment.id,
                            description: this.realignmentDescription,
                            note: this.notes,
                            reason: this.reason,
                            // apiId: this.apiId,
                            newApiOpcrId: this.newApiOpcrId,
                            newApiTargetId: this.newApiTargetId,
                            newApiName: this.newApiName,
                        }
                    )
                    .then((res) => {
                        this.showPO = false;
                        this.draftRealignment.description = this.realignmentDescription;
                        this.draftRealignment.newApiName = this.newApiName;
                        this.draftRealignment.note = this.notes;
                        // this.draftRealignment.apiId = this.apiId;
                        this.draftRealignment.newApiOpcrId = this.newApiOpcrId;
                        this.draftRealignment.newApiTargetId = this.newApiTargetId;
                        this.$emit('create-realignment', this.draftRealignment)
                        this.showToast('Successfully updated!', 'success');
                    })
                    .catch((err) => {
                        this.showToast('Something went wrong!', 'error');
                    });
            }else{
                this.$store
                    .dispatch("realignmentrequest/CreateRealignment", 
                        {
                            cycle: this.$store.state.data.cycle,
                            deliveryUnitId: this.$store.state.data.selectedDU.id,
                            description: this.realignmentDescription,
                            note: this.notes,
                            reason: this.reason,
                            // apiId: this.apiId,
                            newApiName: this.newApiName,
                            newApiOpcrId: this.newApiOpcrId,
                            newApiTargetId: this.newApiTargetId,
                        }
                    )
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        this.showPO = false;    
                        this.proposalLoaded = true;
                        this.realignmentDescription = "";
                        // res.data.api = this.selectedAPI;
                        this.$emit('create-realignment', res.data)
                        this.showToast('Successfully created!', 'success');
                    })
                    .catch((err) => {
                        this.showToast('Something went wrong!', 'error');
                    });
            }
        },
        async removeAllRealignmentItems(){
            let error = 0;
            for (const row of this.tableData){
                await this.$store
                    .dispatch("realignmentrequestitem/DeleteRealignment", row.id)
                    .then((res) => {})
                    .catch(err => {
                        error++
                    }
                );
            }

            if(error > 0){
                this.showToast("Something went wrong!", "error");
            }else{
                this.$emit('delete-all-item');
            }
            return true;
        },
        async removeAllProposal(){
            let error = 0;
            for(const row of this.modificationProposal){
                await this.$store
                    .dispatch("realignmentaccount/RemoveRealignmentAccount", row.id)
                    .then((res) => {
                        let index = this.modificationProposal.findIndex((item) => item.id == row.id);
                        this.modificationProposal.splice(index, 1);
                        this.proposalCopy = cloneDeep(this.modificationProposal);
                    })
                    .catch((err) => {
                        error++
                    }
                );
            }
            if(error > 0){
                this.showToast("Something went wrong!", "error");
            }
            return true;
        },
        removeRealignment(){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    if(this.tableData.length > 0){
                        await this.removeAllRealignmentItems();
                    }
                    if(this.modificationProposal.length > 0){
                        await this.removeAllProposal();
                    }
                    await this.$store
                        .dispatch("realignmentrequest/DeleteRealignment", this.draftRealignment.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.realignmentDescription = "";
                                this.$emit("remove-realignment")
                                this.showToast("Successfully removed!","success");
                            }
                        })
                        .catch((err) => {
                            this.showToast("Remove details first!", "error");
                        });
                }
            });
        },
        updateItem(item){
            this.totalReduceQty = 0;
            item.editQty = true;
            item.maxValue = cloneDeep(item.quantity);
            item.monthValue = cloneDeep(item.quantity.toString());
        },
        addQty(row){
            row.monthValue = row.monthValue + 1;
            this.totalReduceQty--
        },
        reduceQty(row){
            row.monthValue = row.monthValue - 1;
            this.totalReduceQty++
        },
        removeFromModification(row){
            let deleteModification = row.monthValue == 0 ? true : false;
            if(deleteModification){
                Swal.fire({
                    title: "Are you sure?",
                    text: "You put the quantity to zero. This will delete the item from the modification list. Do you want to continue?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, remove it!",
                }).then(async (result) => {
                    if (result.value) {
                        this.$store
                            .dispatch("realignmentrequestitem/DeleteRealignment", row.id)
                            .then((res) => {
                                if (res.status == 204) {
                                    this.$emit("delete-item", row.id);
                                }
                            })
                            .catch((err) => {
                                this.showToast("Cannot be removed!", "error");
                            }
                        );
                    }
                });
            }else{
                let data = {
                    id: row.id,
                    quantity: row.monthValue,
                    apiResourceDetailId: row.apiResourceDetailId,
                }
                this.$store
                    .dispatch("realignmentrequestitem/UpdateRealignment", data)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error")
                        }
                        row.quantity = row.monthValue;
                        row.total = parseFloat(row.monthValue) * parseFloat(row.apiResourceDetail.apiResource.inflatedUnitCost);
                        row.editQty = false;
                        this.$emit("update-item", row);
                        this.showToast("Successfully updated!", "success")
                    })
                    .catch((err) => {
                        this.showToast("Cannot be update!", "error");
                    }
                );
            }
        },
        postRealignment(){
            if(this.tableData.length == 0){
                this.showToast("No item to post!", "error");
                return;
            }
            if(this.modificationProposal.length == 0){
                this.showToast("No modification proposal!", "error");
                return;
            }
            if((this.totalLineBudget.toFixed(2) - this.totalExpenditure.toFixed(2)) > 0){
                this.showToast("Part II and Part III should be equal. If you want only this amount to be reflected in your modification, please contact DTO for assistance.", "warning");
                return;
            }
            Swal.fire({
                    title: "Are you sure?",
                    text: "You want to post this?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, post this!",
                }).then(async (result) => {
                    if (result.value) {
                        this.$store
                            .dispatch("realignmentrequest/PostRealignment", this.draftRealignment.id)
                            .then((res) => {
                                if(res.data.error){
                                    return this.showToast(res.data.errorMessage, "error")
                                }
                                this.realignmentDescription = "";
                                this.$emit("post-realignment")
                                this.showToast("Successfully posted!", "success")
                            })
                            .catch((err) => {
                                this.showToast("Cannot be posted!", "error");
                            }
                        );
                    }
                });
        },
        createNewRealignment(){
            this.showPO = true;
            this.draftRealignment = null;
            this.realignmentDescription = "";
            this.reason = 0;
            this.notes = "";
            this.getAvailableApis();
        },
        onResetProposal(){
            this.proposal = {
                id: 0,
                accountId: null,
                account: null,
                q1: "",
                q2: "",
                q3: "",
                q4: "",
                editMode: false,
            }
            this.$v.proposal.$reset();
        },
        proposeModification(){
            this.getAvailableAccounts();
            this.$bvModal.show('modification-proposal-modal');
        },
        addMoreProposal(){
            this.onResetProposal();
            this.addMore = true;
        },
        cancelProposal(){
            this.onResetProposal();
            this.addMore = false;
        },
        async getProposedModifications(id){
            this.proposalLoading = true;
            this.proposalLoaded = false;
            this.modificationProposal = [];
            await this.$store
                .dispatch("realignmentaccount/GetAllRealignmentAccount", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error")
                    }
                    res.data.map(item => {
                        item.editMode = false;
                        item.account = {
                            id: item.accountId,
                            accountGroup: item.accountGroup
                        }
                    })
                    this.modificationProposal = res.data;
                    this.proposalCopy = cloneDeep(res.data);
                })
                .catch((err) => {
                    this.showToast("Cannot be added!", "error");
                });
            this.proposalLoading = false;
            this.proposalLoaded = true;
        },
        saveProposal(){
            this.proposal.submitted = false;
            this.$v.proposal.$touch();
            if(this.$v.proposal.$invalid){
                return;
            }
            this.proposal.submitted = true;
            if(this.proposal.q1 == 0 && this.proposal.q2 == 0 && this.proposal.q3 == 0 && this.proposal.q4 == 0){
                return;
            }
            if(parseFloat(this.totalExpenditure.toFixed(2)) > parseFloat(this.totalLineBudget.toFixed(2))){
                return this.showToast('Total proposed modification is greater than total line item budget', 'error');
            }
            let data = cloneDeep(this.proposal);
            data.q1 = this.proposal.q1 ? this.getExactAmt(this.proposal.q1) : 0;
            data.q2 = this.proposal.q2 ? this.getExactAmt(this.proposal.q2) : 0;
            data.q3 = this.proposal.q3 ? this.getExactAmt(this.proposal.q3) : 0;
            data.q4 = this.proposal.q4 ? this.getExactAmt(this.proposal.q4) : 0;
            data.accountGroup = this.proposal.account.accountGroup;
            data.realignmentRequestId = this.draftRealignment.id;
            if(this.proposal.id > 0){
                this.$store
                    .dispatch("realignmentaccount/UpdateRealignmentAccount", data)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error")
                        }
                        let index = this.modificationProposal.findIndex(item => item.id == data.id);
                        data.editMode = false;
                        this.modificationProposal.splice(index, 1, data);
                        this.proposalCopy = cloneDeep(this.modificationProposal);
                        this.onResetProposal();
                        this.showToast("Successfully added!", "success")
                    })
                    .catch((err) => {
                        this.showToast("Cannot be added!", "error");
                    }
                );
            }else{
                this.$store
                    .dispatch("realignmentaccount/CreateRealignmentAccount", [data])
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error")
                        }
                        res.data.forEach((item) => {
                            item.account = data.account;
                            item.editMode = false;
                            item.accountGroup = data.accountGroup;
                            this.modificationProposal.push(item);
                        });
                        this.proposalCopy = cloneDeep(this.modificationProposal);
                        this.onResetProposal();
                        this.addMore = false;
                        this.showToast("Successfully added!", "success")
                    })
                    .catch((err) => {
                        this.showToast("Cannot be added!", "error");
                    }
                );
            }
        },
        selectAccount(row){
            this.proposal.accountId = row.id;
            this.proposal.account = {
                id: row.id,
                accountGroup: row.accountGroup,
            }
        },
        updateProposal(row){
            this.modificationProposal.map(item => item.editMode = false)
            let copyIndex = this.proposalCopy.findIndex((item) => item.id == row.id);
            if(copyIndex > -1){
                this.proposalCopy.splice(copyIndex, 1);
            }
            row.editMode = true;
            this.proposal = cloneDeep(row);
            this.proposal.q1 = row.q1.toString();
            this.proposal.q2 = row.q2.toString();
            this.proposal.q3 = row.q3.toString();
            this.proposal.q4 = row.q4.toString();
            this.proposal.account = {
                id: row.accountId,
                accountGroup: row.accountGroup,
            }
            this.copiedProposal = cloneDeep(row);
            this.proposal.editMode = true;
            
        },
        deleteProposal(row){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("realignmentaccount/RemoveRealignmentAccount", row.id)
                        .then((res) => {
                            let index = this.modificationProposal.findIndex((item) => item.id == row.id);
                            this.modificationProposal.splice(index, 1);
                            this.proposalCopy = cloneDeep(this.modificationProposal);
                            this.showToast("Successfully deleted!", "success")
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        }
                    );
                }
            });
        },
        cancelUpdateProposal(row){
            row.editMode = false;
            this.proposalCopy.push(this.copiedProposal)
            this.onResetProposal();
        },
        async getAvailableApis(){
            await this.$store
                .dispatch("realignmentrequest/GetAvailableAPI", {deliveryUnitId: this.$store.state.data.selectedDU.id, cycle: this.$store.state.data.cycle})
                .then((res) => {
                    this.availableApis = res.data;
                    if(this.availableApis.length > 0){
                        this.selectedAPI = cloneDeep(this.availableApis[0]);
                        this.apiId = cloneDeep(this.availableApis[0].id);
                    }
                })
                .catch((err) => {
                    this.showToast("Something went wrong getting available APIs!", "error");
                })
        },
        selectApi(row){
            this.apiId = row.id;
        },
        selectOpcr(row){
            this.newApiOpcrId = row.id
        },
        selectTarget(row){
            this.newApiTargetId = row.id
        },
        inputHandler(event, row){
            const value = event.target.value + '' + event.key;
            if(parseFloat(value) > parseFloat(row.maxValue)){
                event.preventDefault();
            }
        },
        changeItemValue(row){
            this.totalReduceQty = parseFloat(row.maxValue) - parseFloat(row.monthValue);
        }
    },
}
</script>
<template>
    <div>
        <b-modal
            id="modification-proposal-modal"
            title="Propose Modification"
            size="xl"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            
        </b-modal>
        <div class="d-flex justify-content-between align-items-center">
            <label
                class="d-inline-flex align-items-center mb-0 me-1"
            >
                <b-form-input
                    autocomplete="off"
                    v-model.lazy="filter"
                    type="search"
                    placeholder="Search Item Resources..."
                    class="form-control"
                    style="width: 300px;"
                ></b-form-input>
                <b-form-select
                    class="form-select ms-1 w-25"
                    v-model="perPage"
                    :options="pageOptions"
                ></b-form-select>
            </label>
            <b-popover
                v-if="!draftRealignment"
                target="createRealignment"
                triggers="click"
                placement="left"
                custom-class="realignment-popover"
                :show.sync="showPO"
            >
                <template v-slot:title>
                    <div class="d-flex align-items-center justify-content-between">
                        <small>Modification Description</small>
                        <span class="bx bx-x font-size-14 cursor-pointer" @click="showPO = false"></span>
                    </div>
                </template>
                <form @submit.prevent="createRequest">
                    <div class="mb-2">
                        <label for="" class="text-warning">Modification Description</label>
                        <textarea
                            rows="1"
                            type="text"
                            class="form-control resize-none"
                            placeholder="Modification Description"
                            v-model="realignmentDescription"
                            @input="autoGrow($event, 15)"
                            :class="{
                                'is-invalid': $v.realignmentDescription.$error,
                            }"
                        />
                    </div>
                    <div>
                        <label><span class="text-warning">Modification Reason:</span> <span v-if="submitted && reason == 0" class="text-danger"> - Select Reason</span></label>
                    </div>
                    <div class="d-flex align-items-center cursor-pointer mb-2" @click="reason = 1">
                        <div style="height:20px;width:30px" class="border me-2" :class="{'bg-warning': reason == 1}"></div>
                        Unforeseen modification or adjustment in the Activity/Program/Initiative (API)
                    </div>
                    <div class="d-flex align-items-center cursor-pointer mb-2" @click="reason = 2">
                        <div style="height:20px;width:30px" class="border me-2" :class="{'bg-warning': reason == 2}"></div>
                        Re-assessment in the use. Prioritization and/or distribution of resources
                    </div>
                    <div class="d-flex align-items-center cursor-pointer mb-2" @click="reason = 3">
                        <div style="height:20px;width:30px" class="border me-2" :class="{'bg-warning': reason == 3}"></div>
                        Additional requirements for an API in view of a declaration of a state of calamity
                    </div>
                    <div class="mb-2">
                        <label class="text-warning">Note:</label>
                        <textarea
                            rows="1"
                            type="text"
                            class="form-control resize-none"
                            placeholder="Modification Notes"
                            v-model="notes"
                            @input="autoGrow($event, 15)"
                            :class="{
                                'is-invalid': $v.notes.$error,
                            }"
                        />
                    </div>
                    <!-- <div class="mb-2">
                        <label class="text-warning">API:</label>
                        <multiselect
                            v-model="selectedAPI"
                            :options="availableApis"
                            label="name"
                            @select="selectApi"
                            track-by="id"
                            value="id"
                            deselect-label=""
                            select-label=""
                            :allow-empty="false"
                            :class="{'is-invalid': $v.apiId.$error}"
                        />
                        <div v-if="$v.apiId.$error" class="invalid-feedback">
                            <span v-if="!$v.apiId.required">This value is required.</span>
                        </div>
                    </div> -->
                    <div class="mb-2">
                        <label class="text-warning">OPCR:</label>
                        <multiselect
                            v-model="selectedOPCR"
                            :options="opcrs"
                            label="title"
                            @select="selectOpcr"
                            track-by="id"
                            value="id"
                            deselect-label=""
                            select-label=""
                            :allow-empty="false"
                            :class="{'is-invalid': $v.newApiOpcrId.$error}"
                        />
                        <div v-if="$v.newApiOpcrId.$error" class="invalid-feedback">
                            <span v-if="!$v.newApiOpcrId.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-2">
                        <label class="text-warning">Target:</label>
                        <multiselect
                            v-model="selectedTarget"
                            :options="targets"
                            label="remarks"
                            @select="selectTarget"
                            track-by="id"
                            value="id"
                            deselect-label=""
                            select-label=""
                            :allow-empty="false"
                            :class="{'is-invalid': $v.newApiTargetId.$error}"
                        />
                        <div v-if="$v.newApiTargetId.$error" class="invalid-feedback">
                            <span v-if="!$v.newApiTargetId.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-2">
                        <label class="text-warning">New API Name:</label>
                        <input type="text" class="form-control" v-model="newApiName" :class="{'is-invalid': $v.newApiName.$error}">
                        <div v-if="$v.newApiName.$error" class="invalid-feedback">
                            <span v-if="!$v.newApiName.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="submit"
                            class="btn btn-success btn-sm"
                        >
                            Create
                        </button>
                        <button
                            type="button"
                            class="btn btn-link btn-sm"
                            @click="showPO = false"
                        >
                            Close
                        </button>
                    </div>
                </form>
            </b-popover>
            <div>
                <button v-if="!draftRealignment" type="button" class="btn btn-success" id="createRealignment" @click="createNewRealignment">Create Modification</button>
                <!-- <button v-if="draftRealignment" type="button" class="btn btn-info me-2" id="proposeModification" @click="proposeModification"><i class="bx bx-collapse"></i> Propose Modification</button> -->
                <button v-if="draftRealignment && proposalLoaded" type="button" class="btn btn-success" id="createRealignment" @click="postRealignment"><i class="bx bx-check"></i> Post Modification</button>
            </div>
        </div>
        <div>
            <div v-if="draftRealignment" class="mt-2">
                <div class="mb-1 p-3 broken-border" >
                    <div class="d-flex justify-content-between">
                        <h4 class="mb-0">{{draftRealignment.description}}</h4>
                        <div>
                            <a href="javascript:void(0);" class="text-success" id="updateRealignment" @click="updateRealignment"><i class="bx bx-edit"></i> Update Modification</a> 
                            <b-popover
                                target="updateRealignment"
                                triggers="click"
                                placement="right"
                                custom-class="realignment-popover"
                                :show.sync="showPO"
                            >
                                <template v-slot:title
                                    ><small>Update Modification</small></template
                                >
                                <form @submit.prevent="createRequest">
                                    <div class="mb-2">
                                        <label for="" class="text-warning">Modification Description</label>
                                        <textarea
                                            rows="1"
                                            type="text"
                                            class="form-control resize-none"
                                            placeholder="Modification Description"
                                            v-model="realignmentDescription"
                                            @input="autoGrow($event, 15)"
                                            :class="{
                                                'is-invalid': $v.realignmentDescription.$error,
                                            }"
                                        ></textarea>
                                    </div>
                                    <div>
                                        <label><span class="text-warning">Modification Reason:</span> <span v-if="submitted && reason == 0" class="text-danger"> - Select Reason</span></label>
                                    </div>
                                    <div class="d-flex align-items-center cursor-pointer mb-2" @click="reason = 1">
                                        <div style="height:20px;width:30px" class="border me-2" :class="{'bg-warning': reason == 1}"></div>
                                        Unforeseen modification or adjustment in the Activity/Program/Initiative (API)
                                    </div>
                                    <div class="d-flex align-items-center cursor-pointer mb-2" @click="reason = 2">
                                        <div style="height:20px;width:30px" class="border me-2" :class="{'bg-warning': reason == 2}"></div>
                                        Re-assessment in the use. Prioritization and/or distribution of resources
                                    </div>
                                    <div class="d-flex align-items-center cursor-pointer mb-2" @click="reason = 3">
                                        <div style="height:20px;width:30px" class="border me-2" :class="{'bg-warning': reason == 3}"></div>
                                        Additional requirements for an API in view of a declaration of a state of calamity
                                    </div>
                                    <div class="mb-2">
                                        <label class="text-warning">Note:</label>
                                        <textarea
                                            rows="1"
                                            type="text"
                                            class="form-control resize-none"
                                            placeholder="Modification Notes"
                                            v-model="notes"
                                            @input="autoGrow($event, 15)"
                                            :class="{
                                                'is-invalid': $v.notes.$error,
                                            }"
                                        />
                                    </div>
                                    <!-- <div class="mb-2">
                                        <label class="text-warning">API:</label>
                                        <div class="form-control">{{draftRealignment.api.name}}</div>
                                    </div> -->
                                    <div class="mb-2">
                                        <label class="text-warning">OPCR:</label>
                                        <multiselect
                                            v-model="selectedOPCR"
                                            :options="opcrs"
                                            label="title"
                                            @select="selectOpcr"
                                            track-by="id"
                                            value="id"
                                            deselect-label=""
                                            select-label=""
                                            :allow-empty="false"
                                            :class="{'is-invalid': $v.newApiOpcrId.$error}"
                                        />
                                        <div v-if="$v.newApiOpcrId.$error" class="invalid-feedback">
                                            <span v-if="!$v.newApiOpcrId.required">This value is required.</span>
                                        </div>
                                    </div>
                                    <div class="mb-2">
                                        <label class="text-warning">Target:</label>
                                        <multiselect
                                            v-model="selectedTarget"
                                            :options="targets"
                                            label="remarks"
                                            @select="selectTarget"
                                            track-by="id"
                                            value="id"
                                            deselect-label=""
                                            select-label=""
                                            :allow-empty="false"
                                            :class="{'is-invalid': $v.newApiTargetId.$error}"
                                        />
                                        <div v-if="$v.newApiTargetId.$error" class="invalid-feedback">
                                            <span v-if="!$v.newApiTargetId.required">This value is required.</span>
                                        </div>
                                    </div>
                                    <div class="mb-2">
                                        <label class="text-warning">New API Name:</label>
                                        <input type="text" class="form-control" v-model="newApiName">
                                    </div>
                                    <div class="modal-footer">
                                        <button
                                            type="submit"
                                            class="btn btn-success btn-sm"
                                        >
                                            Update
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-link btn-sm"
                                            @click="showPO = false"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </form>
                            </b-popover>
                            <span class="mx-2">|</span> 
                            <a href="javascript:void(0);" class="text-danger" @click="removeRealignment"><i class="bx bx-trash"></i> Remove Modification</a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="border p-3 rounded">
                                <h5 class="text-pink">Part 1: Reason of Modification of Budget</h5>
                                <p class="mb-0">
                                    <span class="text-info">Reason: </span>
                                    <span class="text-light">{{reasons[draftRealignment.reason - 1]}}</span>
                                </p>
                                <p class="mb-0">
                                    <span class="text-info">Explanation: </span>
                                    <span class="text-light">{{draftRealignment.note}}</span>
                                </p>
                                <hr class="mt-2 mb-3 text-warning">
                                <h5 class="text-pink">Part 2: Approved Line Item Budget to be Modified</h5>
                                <!-- <p class="mb-0" v-if="draftRealignment.api.goal">
                                    <span class="text-info">Goal: </span>
                                    <span class="text-light">{{draftRealignment.api.goal}}</span>
                                </p>
                                <p class="mb-0" v-if="draftRealignment.api.prexc">
                                    <span class="text-info">PREXC: </span>
                                    <span class="text-light">{{draftRealignment.api.prexc}}</span>
                                </p>
                                <p>
                                    <span class="text-info">Activity: </span>
                                    <span class="text-light">{{draftRealignment.api.name}}</span>
                                </p> -->
                                <div class="table-responsive">
                                    <table
                                        class="
                                            table
                                            project-list-table
                                            table-centered
                                            table-borderless
                                            align-middle
                                            resource-item-table
                                        "
                                    >
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    Item Name
                                                </th>
                                                <th
                                                    scope="col"
                                                    width="150px"
                                                    class="
                                                        text-center
                                                    "
                                                >
                                                    Quantity
                                                </th>
                                                <th
                                                    scope="col"
                                                    width="150px"
                                                >
                                                    Unit Cost
                                                </th>
                                                <th
                                                    scope="col"
                                                    width="150px"
                                                >
                                                    Total
                                                </th>
                                                <th
                                                    scope="col"
                                                    width="100px"
                                                    class="
                                                        text-center
                                                    "
                                                >
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-if="
                                                    tableData.length ==
                                                        0
                                                "
                                            >
                                                <td
                                                    colspan="5"
                                                    class="
                                                        text-muted
                                                        text-center
                                                    "
                                                >
                                                    <i
                                                        class="
                                                            dripicons-warning
                                                            me-1
                                                        "
                                                    ></i
                                                    >No data
                                                    found
                                                </td>
                                            </tr>
                                            <tr
                                                v-if="tableData.length > 0 && filtered.length == 0"
                                            >
                                                <td
                                                    colspan="5"
                                                    class="
                                                        text-muted
                                                        text-center
                                                    "
                                                >
                                                    <i
                                                        class="
                                                            dripicons-warning
                                                            me-1
                                                        "
                                                    ></i
                                                    >Search not
                                                    found
                                                </td>
                                            </tr>
                                            <template v-if="filtered.length > 0">
                                                <tr
                                                    v-for="x in filtered"
                                                    :key="x.id"
                                                    :ref="`resource-tr-${x.id}`"
                                                >
                                                    <td
                                                        class="
                                                            border
                                                            border-end-0
                                                            position-relative
                                                        "
                                                    >
                                                        <RawData 
                                                            :data="x" 
                                                            v-if="$store.state.decrypt.isAdmin()" 
                                                        />
                                                        <div>
                                                            {{
                                                                x.apiResourceDetail.apiResource.itemName
                                                            }}
                                                        </div>
                                                        <small>{{x.apiResourceDetail.apiResource.description}}</small>
                                                        <div class="d-flex align-items-center mb-1">
                                                            <span class="badge bg-secondary text-white py-1 px-2 me-2">{{ x.fundSource }}</span>
                                                            <span class="badge bg-purple text-white py-1 px-2">{{ x.fundClass }}</span>
                                                            <span class="badge bg-success text-white py-1 px-2 me-2"> {{ x.accountGroup }}</span>
                                                            <span class="badge bg-primary text-white py-1 px-2">{{x .accountName}}</span>
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="
                                                            border
                                                            border-start-0
                                                            border-end-0
                                                            text-center
                                                        "
                                                        
                                                    >
                                                        <span :id="`edit-itemQ-${x.id}`" class="px-2">{{
                                                            numberWithCommas(x.quantity)
                                                        }}</span>
                                                        <b-popover
                                                                :show.sync="
                                                                x.editQty
                                                            "
                                                            :target="`edit-itemQ-${x.id}`"
                                                            custom-class="one-month-resource"
                                                            triggers="click"
                                                            placement="left"
                                                        >
                                                            <template
                                                                v-slot:title
                                                            >
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                        justify-content-between
                                                                    "
                                                                >
                                                                    <small>
                                                                        Item Resource Details
                                                                    </small>
                                                                    <span
                                                                        class="
                                                                            bx
                                                                            bx-x
                                                                            font-size-14
                                                                            cursor-pointer
                                                                        "
                                                                        @click="
                                                                            x.editQty = false
                                                                        "
                                                                    ></span>
                                                                </div>
                                                            </template>
                                                            <div>
                                                                <label for="Jan" class="mb-0">{{x.apiResourceDetail.month.monthName}} <span>(Max: {{x.maxValue}})</span></label>
                                                                <b-input-group>
                                                                    <!-- <template
                                                                        #prepend
                                                                        v-if="x.maxValue > 0"
                                                                    >
                                                                        <b-button
                                                                            @click="
                                                                                reduceQty(x)
                                                                            "
                                                                            :disabled="x.monthValue == 0"
                                                                            variant="outline-danger"
                                                                            class="btn-sm"
                                                                            ><i
                                                                                class="
                                                                                    bx bx-minus
                                                                                "
                                                                            ></i
                                                                        ></b-button>
                                                                    </template>
                                                                    <template
                                                                        #append
                                                                        v-if="x.maxValue > 0"
                                                                    >
                                                                        <b-button
                                                                            @click="
                                                                                addQty(x)
                                                                            "
                                                                            :disabled="x.monthValue == x.maxValue"
                                                                            variant="outline-info"
                                                                            class="btn-sm"
                                                                            ><i
                                                                                class="
                                                                                    bx bx-plus
                                                                                "
                                                                            ></i
                                                                        ></b-button>
                                                                    </template> -->
                                                                    <!-- <div class="form-control form-control-sm text-center">{{x.monthValue}}</div> -->
                                                                    <masked-input 
                                                                        :mask="quantityMask" 
                                                                        type="text" 
                                                                        class="form-control form-control-sm text-center"  
                                                                        v-model="x.monthValue"
                                                                        @keypress="inputHandler($event, x)"
                                                                        @keyup="changeItemValue(x)"
                                                                    ></masked-input>
                                                                </b-input-group>
                                                            </div>
                                                            <div
                                                                class="
                                                                    text-right
                                                                    mt-2
                                                                "
                                                            >
                                                                <button
                                                                    type="button"
                                                                    class="
                                                                        btn
                                                                        btn-success
                                                                        btn-sm
                                                                        me-2
                                                                    "
                                                                    v-if="totalReduceQty > 0"
                                                                    @click="
                                                                        removeFromModification(x)
                                                                    "
                                                                >
                                                                    Update
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    class="
                                                                        btn
                                                                        btn-link
                                                                        btn-sm
                                                                    "
                                                                    @click="
                                                                    x.editQty = false
                                                                    "
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </b-popover>
                                                        <div>
                                                            <small class="text-warning">({{x.apiResourceDetail.month.monthName}})</small>
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="
                                                            border
                                                            border-start-0
                                                            border-end-0
                                                        "
                                                    >
                                                        {{
                                                            formatCurrency(
                                                                x.apiResourceDetail.apiResource.inflatedUnitCost
                                                            )
                                                        }}
                                                    </td>
                                                    <td class="border border-start-0 border-end-0">
                                                        {{ formatCurrency(x.total) }}
                                                    </td>
                                                    <td
                                                        class="
                                                            text-center
                                                            border
                                                            border-start-0
                                                        "
                                                    >
                                                        <b-dropdown
                                                            class="
                                                                card-drop
                                                            "
                                                            menu-class="dropdown-menu-end"
                                                            variant="white"
                                                            toggle-class="p-0"
                                                        >
                                                            <template
                                                                v-slot:button-content
                                                            >
                                                                <i
                                                                    class="
                                                                        mdi
                                                                        mdi-dots-horizontal
                                                                        font-size-18
                                                                    "
                                                                ></i>
                                                            </template>
                                                            <b-dropdown-item
                                                                @click="
                                                                    updateItem(
                                                                        x
                                                                    )
                                                                "
                                                                variant="dark"
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-edit
                                                                        font-size-18
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Edit</b-dropdown-item
                                                            >
                                                            <b-dropdown-item
                                                                @click="
                                                                    deleteItem(
                                                                        x.id
                                                                    )
                                                                "
                                                                variant="danger"
                                                                ><i
                                                                    class="
                                                                        bx
                                                                        bx-trash
                                                                        font-size-18
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Delete</b-dropdown-item
                                                            >
                                                        </b-dropdown>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <hr class="mt-2 mb-3 text-warning">
                                <div v-if="draftRealignment">
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <h5 class="text-pink">Part 3: Proposed Modification</h5>
                                            <p><span class="text-info">New Activity Name:</span> {{draftRealignment.newApiName}}</p>
                                        </div>
                                        <div class="text-right">
                                            <h6>Total Line Item Budget: <span class="text-warning">{{formatCurrency(totalLineBudget)}}</span></h6>
                                            <h6>Total Proposed Modification: <span class="text-warning" :class="{'text-danger': parseFloat(totalExpenditure.toFixed(2)) > parseFloat(totalLineBudget.toFixed(2))}">{{formatCurrency(totalExpenditure)}}</span></h6>
                                            <h6>Total Balance LIB: <span class="text-warning" :class="{'text-danger': (totalLineBudget.toFixed(2) - totalExpenditure.toFixed(2)) < 0}">{{formatCurrency(totalLineBudget.toFixed(2) - totalExpenditure.toFixed(2))}}</span></h6>
                                        </div>
                                    </div>
                                    <table class="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Object of Expenditure</th>
                                                <th width="150px">Quarter 1</th>
                                                <th width="150px">Quarter 2</th>
                                                <th width="150px">Quarter 3</th>
                                                <th width="150px">Quarter 4</th>
                                                <th width="90px">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="!proposalLoading && modificationProposal.length == 0">
                                                <td colspan="6" class="text-center">No data available</td>
                                            </tr>
                                            <tr v-if="proposalLoading">
                                                <td colspan="6" class="text-center">
                                                    <div class="spinner-border text-primary" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <template v-if="!proposalLoading && modificationProposal.length > 0">
                                                <tr v-for="propose in modificationProposal" :key="propose.id">
                                                    <td>
                                                        <div v-if="!propose.editMode">{{propose.accountGroup}}</div>
                                                        <div v-else>
                                                            <template v-if="accountsLoading">
                                                                <div class="spinner-border text-primary" role="status">
                                                                    <span class="visually-hidden">Loading...</span>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <multiselect
                                                                    v-model="propose.account"
                                                                    :options="availableAccounts"
                                                                    label="accountGroup"
                                                                    @select="selectAccount"
                                                                    track-by="id"
                                                                    value="id"
                                                                    deselect-label=""
                                                                    select-label=""
                                                                    :allow-empty="false"
                                                                    :class="{'is-invalid': $v.proposal.accountId.$error}"
                                                                />
                                                                <div v-if="$v.proposal.accountId.$error" class="invalid-feedback">
                                                                    <span v-if="!$v.proposal.accountId.required">This value is required.</span>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-if="!propose.editMode">{{propose.q1 > 0 ? formatCurrency(propose.q1) : '-'}}</div>
                                                        <div v-else>
                                                            <masked-input
                                                                autocomplete="off"
                                                                type="text"
                                                                v-model="proposal.q1"
                                                                class="form-control"
                                                                :mask="currencyMask"
                                                                :class="{'is-invalid': proposal.submitted && !proposal.q1 && !proposal.q2 && !proposal.q3 && !proposal.q4}"
                                                            ></masked-input>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-if="!propose.editMode">{{propose.q2 > 0 ? formatCurrency(propose.q2) : '-'}}</div>
                                                        <div v-else>
                                                            <masked-input
                                                                autocomplete="off"
                                                                type="text"
                                                                v-model="proposal.q2"
                                                                class="form-control"
                                                                :mask="currencyMask"
                                                                :class="{'is-invalid': proposal.submitted && !proposal.q1 && !proposal.q2 && !proposal.q3 && !proposal.q4}"
                                                            ></masked-input>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-if="!propose.editMode">{{propose.q3 > 0 ? formatCurrency(propose.q3) : '-'}}</div>
                                                        <div v-else>
                                                            <masked-input
                                                                autocomplete="off"
                                                                type="text"
                                                                v-model="proposal.q3"
                                                                class="form-control"
                                                                :mask="currencyMask"
                                                                :class="{'is-invalid': proposal.submitted && !proposal.q1 && !proposal.q2 && !proposal.q3 && !proposal.q4}"
                                                            ></masked-input>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-if="!propose.editMode">{{propose.q4 > 0 ? formatCurrency(propose.q4) : '-'}}</div>
                                                        <div v-else>
                                                            <masked-input
                                                                autocomplete="off"
                                                                type="text"
                                                                v-model="proposal.q4"
                                                                class="form-control"
                                                                :mask="currencyMask"
                                                                :class="{'is-invalid': proposal.submitted && !proposal.q1 && !proposal.q2 && !proposal.q3 && !proposal.q4}"
                                                            ></masked-input>
                                                        </div>
                                                    </td>
                                                    <td class="text-center align-middle">
                                                        <div v-if="!propose.editMode">
                                                            <a href="javascript:void(0);" @click="updateProposal(propose)" class="me-2"><i class="bx bx-edit text-success fs-5 font-weight-bold"></i></a>
                                                            <a href="javascript:void(0);" @click="deleteProposal(propose)"><i class="bx bx-trash text-danger fs-5 font-weight-bold me-2"></i></a>
                                                        </div>
                                                        <div v-else>
                                                            <a href="javascript:void(0);" @click="saveProposal" class="me-2"><i class="bx bx-check text-success fs-5 font-weight-bold"></i></a>
                                                            <a href="javascript:void(0);" @click="cancelUpdateProposal(propose)"><i class="bx bx-x text-danger fs-5 font-weight-bold me-2"></i></a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                            <tr v-if="addMore">
                                                <td>
                                                    <template v-if="accountsLoading">
                                                        <div class="spinner-border text-primary" role="status">
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <multiselect
                                                            v-model="proposal.account"
                                                            :options="availableAccounts"
                                                            label="accountGroup"
                                                            @select="selectAccount"
                                                            track-by="id"
                                                            value="id"
                                                            deselect-label=""
                                                            select-label=""
                                                            :allow-empty="false"
                                                            :class="{'is-invalid': $v.proposal.accountId.$error}"
                                                        />
                                                        <div v-if="$v.proposal.accountId.$error" class="invalid-feedback">
                                                            <span v-if="!$v.proposal.accountId.required">This value is required.</span>
                                                        </div>
                                                    </template>
                                                </td>
                                                <td>
                                                    <masked-input
                                                        autocomplete="off"
                                                        type="text"
                                                        v-model="proposal.q1"
                                                        class="form-control"
                                                        :class="{'is-invalid': proposal.submitted && !proposal.q1 && !proposal.q2 && !proposal.q3 && !proposal.q4}"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                </td>
                                                <td>
                                                    <masked-input
                                                        autocomplete="off"
                                                        type="text"
                                                        v-model="proposal.q2"
                                                        class="form-control"
                                                        :class="{'is-invalid': proposal.submitted && !proposal.q1 && !proposal.q2 && !proposal.q3 && !proposal.q4}"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                </td>
                                                <td>
                                                    <masked-input
                                                        autocomplete="off"
                                                        type="text"
                                                        v-model="proposal.q3"
                                                        class="form-control"
                                                        :class="{'is-invalid': proposal.submitted && !proposal.q1 && !proposal.q2 && !proposal.q3 && !proposal.q4}"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                </td>
                                                <td>
                                                    <masked-input
                                                        autocomplete="off"
                                                        type="text"
                                                        v-model="proposal.q4"
                                                        class="form-control"
                                                        :class="{'is-invalid': proposal.submitted && !proposal.q1 && !proposal.q2 && !proposal.q3 && !proposal.q4}"
                                                        :mask="currencyMask"
                                                    ></masked-input>
                                                </td>
                                                <td class="text-center align-middle">
                                                    <a href="javascript:void(0);" @click="saveProposal" class="me-2"><i class="bx bx-check text-success fs-5 font-weight-bold"></i></a>
                                                    <a href="javascript:void(0);" @click="cancelProposal"><i class="bx bx-x text-danger fs-5 font-weight-bold me-2"></i></a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-if="!addMore && !proposal.editMode" @click="addMoreProposal">
                                        <button type="button" class="btn btn-success btn-block"><i class="bx bx-plus"></i> Add More</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive" v-else>
                <table
                    class="
                        table
                        project-list-table
                        table-centered
                        table-borderless
                        align-middle
                        resource-item-table
                    "
                >
                    <thead>
                        <tr>
                            <th scope="col">
                                Item Name
                            </th>
                            <th
                                scope="col"
                                width="150px"
                                class="
                                    text-center
                                "
                            >
                                Quantity
                            </th>
                            <th
                                scope="col"
                                width="150px"
                            >
                                Unit Cost
                            </th>
                            <th
                                scope="col"
                                width="150px"
                            >
                                Total
                            </th>
                            <th
                                scope="col"
                                width="100px"
                                class="
                                    text-center
                                "
                            >
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-if="
                                tableData.length ==
                                    0
                            "
                        >
                            <td
                                colspan="5"
                                class="
                                    text-muted
                                    text-center
                                "
                            >
                                <i
                                    class="
                                        dripicons-warning
                                        me-1
                                    "
                                ></i
                                >No data
                                found
                            </td>
                        </tr>
                        <tr
                            v-if="tableData.length > 0 && filtered.length == 0"
                        >
                            <td
                                colspan="5"
                                class="
                                    text-muted
                                    text-center
                                "
                            >
                                <i
                                    class="
                                        dripicons-warning
                                        me-1
                                    "
                                ></i
                                >Search not
                                found
                            </td>
                        </tr>
                        <template v-if="filtered.length > 0">
                            <tr
                            v-for="x in filtered"
                            :key="x.id"
                            :ref="`resource-tr-${x.id}`"
                        >
                            <td
                                class="
                                    border
                                    border-end-0
                                    position-relative
                                "
                            >
                                <RawData 
                                    :data="x" 
                                    v-if="$store.state.decrypt.isAdmin()" 
                                />
                                <div>
                                    {{
                                        x.apiResourceDetail.apiResource.itemName
                                    }}
                                </div>
                                <small>{{x.apiResourceDetail.apiResource.description}}</small>
                            </td>
                            <td
                                class="
                                    border
                                    border-start-0
                                    border-end-0
                                    text-center
                                "
                                
                            >
                                <span :id="`edit-itemQ-${x.id}`" class="px-2">{{
                                    numberWithCommas(x.quantity)
                                }}</span>
                                <b-popover
                                        :show.sync="
                                        x.editQty
                                    "
                                    :target="`edit-itemQ-${x.id}`"
                                    custom-class="one-month-resource"
                                    triggers="click"
                                    placement="left"
                                >
                                    <template
                                        v-slot:title
                                    >
                                        <div
                                            class="
                                                d-flex
                                                align-items-center
                                                justify-content-between
                                            "
                                        >
                                            <small>
                                                Item Resource Details
                                            </small>
                                            <span
                                                class="
                                                    bx
                                                    bx-x
                                                    font-size-14
                                                    cursor-pointer
                                                "
                                                @click="
                                                    x.editQty = false
                                                "
                                            ></span>
                                        </div>
                                    </template>
                                    <div>
                                        <label for="Jan" class="mb-0">{{x.apiResourceDetail.month.monthName}} <span>(Max: {{x.maxValue}})</span></label>
                                        <b-input-group>
                                            <!-- <template
                                                #prepend
                                                v-if="x.maxValue > 0"
                                            >
                                                <b-button
                                                    @click="
                                                        reduceQty(x)
                                                    "
                                                    :disabled="x.monthValue == 0"
                                                    variant="outline-danger"
                                                    class="btn-sm"
                                                    ><i
                                                        class="
                                                            bx bx-minus
                                                        "
                                                    ></i
                                                ></b-button>
                                            </template>
                                            <template
                                                #append
                                                v-if="x.maxValue > 0"
                                            >
                                                <b-button
                                                    @click="
                                                        addQty(x)
                                                    "
                                                    :disabled="x.monthValue == x.maxValue"
                                                    variant="outline-info"
                                                    class="btn-sm"
                                                    ><i
                                                        class="
                                                            bx bx-plus
                                                        "
                                                    ></i
                                                ></b-button>
                                            </template> -->
                                            <!-- <div class="form-control form-control-sm text-center">{{x.monthValue}}</div> -->
                                            <masked-input 
                                                :mask="quantityMask" 
                                                type="text" 
                                                class="form-control form-control-sm text-center"  
                                                v-model="x.monthValue"
                                                @keypress="inputHandler($event, x)"
                                                @keyup="changeItemValue(x)"
                                            ></masked-input>
                                        </b-input-group>
                                    </div>
                                    <div class="text-right mt-2">
                                        <button
                                            type="button"
                                            class="btn btn-success btn-sm me-2"
                                            v-if="totalReduceQty > 0"
                                            @click="removeFromModification(x)"
                                        >
                                            Update
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-link btn-sm"
                                            @click="x.editQty = false"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </b-popover>
                                <div>
                                    <small class="text-warning">({{x.apiResourceDetail.month.monthName}})</small>
                                </div>
                            </td>
                            <td class="border border-start-0 border-end-0">
                                {{ formatCurrency(x.apiResourceDetail.apiResource.inflatedUnitCost) }}
                            </td>
                            <td class="border border-start-0 border-end-0">
                                {{ formatCurrency(x.total) }}
                            </td>
                            <td class="text-center border border-start-0">
                                <b-dropdown
                                    class="card-drop"
                                    menu-class="dropdown-menu-end"
                                    variant="white"
                                    toggle-class="p-0"
                                >
                                    <template v-slot:button-content>
                                        <i class="mdi mdi-dots-horizontal font-size-18"></i>
                                    </template>
                                    <b-dropdown-item
                                        @click="updateItem(x)"
                                        variant="dark"
                                    >
                                        <i class="bx bx-edit font-size-18 me-1"></i>Edit
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        @click="deleteItem(x.id)"
                                        variant="danger"
                                    >
                                        <i class="bx bx-trash font-size-18 me-1"></i>Delete
                                    </b-dropdown-item>
                                </b-dropdown>
                            </td>
                        </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>